import { createFileRoute } from '@tanstack/react-router';

import { SupportPage } from '@support';

export const Route = createFileRoute('/_app/support')({
  component: SupportPage,
});
